import React, { FC } from "react";
import styles from "./CreditReportSummary.module.scss";
import {
  ClipBoardIcon,
  CreditBillIcon,
  CreditClockIcon,
  CreditRecieptIcon,
} from "customIcons";
import { ReportDetails } from "interfaces/common.interface";
import { formatDate, formatTime } from "@utils/common";
import EllipsisWithTooltip from "@features/common/ellipsisWithTooltip/EllipsisWithTooltip";

// ============================================================================
// Types & Interfaces
// ============================================================================
interface CreditReportSummaryProps {
  summaryData: ReportDetails;
}

const CreditReportSummary: FC<CreditReportSummaryProps> = ({ summaryData }) => {
  const uaeTz = "Asia/Dubai";

  // ============================================================================
  // Render
  // ============================================================================
  return (
    <div className={styles["credit-report-summary"]}>
      {/* Order ID */}
      <div className={styles["credit-report-summary__items"]}>
        <div className={styles["credit-report-summary__items__left"]}>
          <ClipBoardIcon />
        </div>
        <div className={styles["credit-report-summary__items__right"]}>
          <h2>{summaryData.id}</h2>
          <p>Credit orderID</p>
        </div>
      </div>

      {/* Promotion Name */}
      <div className={styles["credit-report-summary__items"]}>
        <div className={styles["credit-report-summary__items__left"]}>
          <CreditBillIcon />
        </div>
        <div className={styles["credit-report-summary__items__right"]}>
          <h2>
            <EllipsisWithTooltip text={summaryData.promotion} />
          </h2>
          <p>Promotion Name</p>
        </div>
      </div>

      {/* Credit Date & Time */}
      <div className={styles["credit-report-summary__items"]}>
        <div className={styles["credit-report-summary__items__left-clock"]}>
          <CreditClockIcon />
        </div>
        <div className={styles["credit-report-summary__items__right"]}>
          <h2>
            {formatDate(summaryData?.submitted_on)}{" "}
            {formatTime(summaryData?.submitted_on, "Asia/Dubai", {
              ampm: true,
            })}{" "}
            UAE
          </h2>
          <p>Credit Date & Time</p>
        </div>
      </div>

      {/* Number of Credits */}
      <div className={styles["credit-report-summary__items"]}>
        <div className={styles["credit-report-summary__items__left-reciept"]}>
          <CreditRecieptIcon />
        </div>
        <div className={styles["credit-report-summary__items__right"]}>
          <h2>{summaryData.quantity}</h2>
          <p>Number of Credits</p>
        </div>
      </div>

      {/* Total Credit Value */}
      <div className={styles["credit-report-summary__items"]}>
        <div className={styles["credit-report-summary__items__right"]}>
          <h2>
            {summaryData.currency} {summaryData.gross_amount}
          </h2>
          <p>Total Credit Value</p>
        </div>
      </div>
    </div>
  );
};

export default CreditReportSummary;
